import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-dialog-download-csv',
    templateUrl: './dialog-download-csv.component.html',
    styleUrls: ['./dialog-download-csv.component.scss'],
    standalone: false
})
export class DialogDownloadCsvComponent implements OnInit {
	constructor() {}

	ngOnInit(): void {}
}
